"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_scroll_1 = require("react-scroll");
const styled_components_1 = require("styled-components");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const arrowDark = require(`../../img/arrows/grey-2x.png`);
const arrowLight = require(`../../img/arrows/white-2x.png`);
const sizeDesktop = 64;
const sizeTablet = 38;
const Arrow = styled_components_1.default.div `
  ${ScreenSizes_1.TABLET_PORTRAIT} {
    align-items: flex-end;
    background-color: ${props => props.color};
    border-top-left-radius: ${sizeTablet * 2}px;
    border-top-right-radius: ${sizeTablet * 2}px;
    bottom: 0;
    display: flex;
    height: ${sizeTablet}px;
    justify-content: center;
    position: absolute;
    right: 0;
    width: ${sizeTablet * 2}px;

    &:hover {
      cursor: pointer;
    }
  }

  ${ScreenSizes_1.DESKTOP} {
    border-top-left-radius: ${sizeDesktop * 2}px;
    border-top-right-radius: ${sizeDesktop * 2}px;
    height: ${sizeDesktop}px;
    width: ${sizeDesktop * 2}px;
  }
`;
const Img = styled_components_1.default.img `
  display: none;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    display: block;
    height: ${sizeTablet / 2}px;
    padding: ${sizeTablet}px ${sizeTablet}px 0 ${sizeTablet}px;

    &:hover {
      transform: translateY(-4px);
      transition-duration: 0.3s;
      transition-property: transform;
      transition-timing-function: ease-in-out;
    }
  }

  ${ScreenSizes_1.DESKTOP} {
    height: ${sizeDesktop / 2}px;
    padding: ${sizeDesktop}}px ${sizeDesktop}}px 0 ${sizeDesktop}}px;
  }
`;
class ArrowLink extends React.Component {
    render() {
        return (React.createElement(react_scroll_1.Link, { to: this.props.target, smooth: true, duration: 500 },
            React.createElement(Arrow, { color: this.props.color, light: this.props.light }, this.props.light ? (React.createElement(Img, { src: arrowLight })) : (React.createElement(Img, { src: arrowDark })))));
    }
}
exports.ArrowLink = ArrowLink;



// WEBPACK FOOTER //
// ./src/components/styled/Arrow.tsx